/* eslint-disable */
import { Injectable } from '@angular/core';
import { AbstractExtensionPattern } from '@libs/libraries/shared';
import { Util } from '@libs/utilities/util';

import { NgCustomizableSliderComponent } from '../customizable-slider.component';
import { NgTick } from '../shared/customizable-slider.data';
import { EnumNgLabelType, INgCustomStepDefinition } from '../shared/customizable-slider.interface';


@Injectable()
export class NgSliderTickHelperExtension extends AbstractExtensionPattern<NgCustomizableSliderComponent> {

	/**------------------------------------------------------
	 * Tick Helpers
	 */
	updateTicksScale() {

		//0 - ticks hidden then set false parent element active
		if (!this.main.viewOptions.showTicks) {
			setTimeout(() => {
				this.main.sliderElementWithLegendClass = false;
			});
			return;
		}

		//1 - ticks array and translate element
		const ticksArray: number[] = Util.Basic.isDefined(this.main.viewOptions.ticksArray) ? this.main.viewOptions.ticksArray! : this.getTicksArray();
		const translate	: string   = this.main.viewOptions.vertical ? 'translateY' : 'translateX';
		if (this.main.viewOptions.rightToLeft) ticksArray.reverse();
		const tickValueStep: number = Util.Basic.isDefined(this.main.viewOptions.tickValueStep)
			? this.main.viewOptions.tickValueStep!
			: (Util.Basic.isDefined(this.main.viewOptions.tickStep)
				? this.main.viewOptions.tickStep
				: this.main.viewOptions.step)!;

		//2 - get all new ticks
		let hasAtLeastOneLegend: boolean = false;
		const newTicks: NgTick[] = ticksArray.map((value: number): NgTick => {

			//a. get position
			let position: number = this.main.sliderHelperExtension.valueToPosition(value);
			if (this.main.viewOptions.vertical) position = this.main.maxHandlePosition - position;

			//b. translation and tick object
			const translation: string = translate + `(${Math.round(position)}px)`;
			const tick		 : NgTick = new NgTick();

			//c. update tick status
			tick.selected = this.isTickSelected(value);
			tick.style 	  = {
				'-webkit-transform'	: translation,
				'-moz-transform'	: translation,
				'-o-transform'		: translation,
				'-ms-transform'		: translation,
				transform			: translation,
			};

			//d. get tick selection color
			if (tick.selected  && Util.Basic.isDefined(this.main.viewOptions.getSelectionBarColor)) (<any>tick.style)['background-color'] = this.main.sliderValueUpdateExtension.getSelectionBarColor();
			if (!tick.selected && Util.Basic.isDefined(this.main.viewOptions.getTickColor)) 		 (<any>tick.style)['background-color'] = this.getTickColor(value);

			//e. set view vertical options
			if (Util.Basic.isDefined(this.main.viewOptions.ticksTooltip)) {
				tick.tooltip 		  = this.main.viewOptions.ticksTooltip!(value);
				tick.tooltipPlacement = this.main.viewOptions.vertical ? 'right' : 'top';
			}

			//f. add style on tick step defined
			if (this.main.viewOptions.showTicksValues && Util.Basic.isDefined(tickValueStep) &&

				// precision limit
				this.main.customizableSliderHelper.isModuloWithinPrecisionLimit(value, tickValueStep, this.main.viewOptions.precisionLimit!)) {
				tick.value = this.main.sliderHelperExtension.getDisplayValue(value, EnumNgLabelType.TickValue);

				// update tick value tooltip and placement
				if (Util.Basic.isDefined(this.main.viewOptions.ticksValuesTooltip)) {
					tick.valueTooltip 		   = this.main.viewOptions.ticksValuesTooltip!(value);
					tick.valueTooltipPlacement = this.main.viewOptions.vertical ? 'right' : 'top';
				}
			}

			//g. check legend status
			let legend: string = null!;
			if (Util.Basic.isDefined(this.main.viewOptions.stepsArray)) {

				// get step and update legend
				const step: INgCustomStepDefinition = this.main.viewOptions.stepsArray![value];
				if (Util.Basic.isDefined(this.main.viewOptions.getStepLegend)) legend = this.main.viewOptions.getStepLegend!(step);
					else if (Util.Basic.isDefined(step)) legend = step.legend!;
			} else if (Util.Basic.isDefined(this.main.viewOptions.getLegend)) {
				legend = this.main.viewOptions.getLegend!(value);
			}

			//h. update tick legend
			if (Util.Basic.isDefined(legend)) {
				tick.legend = legend;
				hasAtLeastOneLegend = true;
			}

			//i. return tick value
			return tick;
		});

		//3 - update legend class
		setTimeout(() => {
			this.main.sliderElementWithLegendClass = hasAtLeastOneLegend;
		});

		//4 - set ticks
		if (Util.Basic.isDefined(this.main.ticks) && this.main.ticks.length === newTicks.length) {
			for (let i: number = 0; i  < newTicks.length; ++i) Object.assign(this.main.ticks[i], newTicks[i]);
		} else {
			this.main.ticks = newTicks;
		}

		//5 - if ref exist then detect changes
		if (!this.main.sliderValueUpdateExtension.isRefDestroyed()) this.main.changeDetectionRef.detectChanges();
	}

	private getTicksArray(): number[] {

		//0 - get step and tick array
		const step: number = (Util.Basic.isDefined(this.main.viewOptions.tickStep)) ? this.main.viewOptions.tickStep! : this.main.viewOptions.step!;
		const ticksArray: number[] = [];

		//1 - number of values
		const numberOfValues: number = 1 + Math.floor(this.main.customizableSliderHelper.roundToPrecisionLimit(
			Math.abs(this.main.viewOptions.ceil! - this.main.viewOptions.floor!) / step, this.main.viewOptions.precisionLimit!
		));

		//2 - update tick array
		for (let index: number = 0; index < numberOfValues; ++index) {
			ticksArray.push(this.main.customizableSliderHelper.roundToPrecisionLimit(this.main.viewOptions.floor! + step * index, this.main.viewOptions.precisionLimit!));
		}
		return ticksArray;
	}

	private isTickSelected(value: number): boolean {

		//0 - update tick selected range
		if (!this.main.range) {
			if (Util.Basic.isDefined(this.main.viewOptions.showSelectionBarFromValue)) {
				const center: number = this.main.viewOptions.showSelectionBarFromValue!;
				if (this.main.viewLowValue > center && value >= center && value <= this.main.viewLowValue) return true;
					else if (this.main.viewLowValue < center && value <= center && value >= this.main.viewLowValue) return true;
			} else if (this.main.viewOptions.showSelectionBarEnd) {
				if (value >= this.main.viewLowValue) return true;
			} else if (this.main.viewOptions.showSelectionBar && value <= this.main.viewLowValue) {
				return true;
			}
		}

		//1 - return selected status
		if (this.main.range && value >= this.main.viewLowValue && value <= this.main.viewHighValue) return true;
		return false;
	}

	//** Get tick color */
	private getTickColor(value: number): string {
		return this.main.viewOptions.getTickColor!(value);
	}
}
